import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  computed,
} from '@angular/core'
import { RouterModule } from '@angular/router'

import {
  AccordionComponent,
  CodeBlockComponent,
  TabBarComponent,
  TabComponent,
  TagComponent,
  TypographyComponent,
} from '@hyperkit'

import { SessionService } from '@hunt/services'
import {
  HuntViewService,
  NavigationService,
  PackageEditorService,
  PackageViewService,
  HydrationService,
} from '@hunt/services'

import { getToolIcon } from '../../../../helpers/utils'
import { ReportQueryHeaderComponent } from '../../report-query-header/report-query-header.component'
import { ReportPivotBlockComponent } from '../report-pivot-block/report-pivot-block.component'
import { ReportTextBlockComponent } from '../report-text-block/report-text-block.component'

@Component({
  standalone: true,
  selector: 'final-report-hunt-package',
  imports: [
    ReportPivotBlockComponent,
    CommonModule,
    RouterModule,
    TypographyComponent,
    TagComponent,
    ReportQueryHeaderComponent,
    AccordionComponent,
    ReportTextBlockComponent,
    TabComponent,
    TabBarComponent,
    CodeBlockComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './final-report-hunt-package.component.html',
  styleUrls: ['final-report-hunt-package.component.scss'],
})
export class FinalReportHuntPackageComponent {
  readonly huntView = inject(HuntViewService)
  readonly packageView = inject(PackageViewService)
  readonly packageEditor = inject(PackageEditorService)
  readonly nav = inject(NavigationService)
  readonly hydration = inject(HydrationService)
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )

  readonly envs = this.packageView.getAllReportEnvironments

  readonly packageId = this.nav.packageId
  readonly tabLabels = ['overview', 'queryNotes']

  // URL-driven subtab (?subtab=overview)
  readonly subtab = this.hydration.query('subtab', 'overview')

  setSubtab(tab: 'overview' | 'queryNotes'): void {
    this.nav.setQueryParam('subtab', tab)
  }

  onSubtabChange(tabLabel: string): void {
    const map: Record<string, 'overview' | 'queryNotes'> = {
      Overview: 'overview',
      'Queries & Notes': 'queryNotes',
    }

    const normalized = map[tabLabel]
    if (normalized) {
      this.nav.setQueryParam('subtab', normalized)
    }
  }

  onSubtabChangeFromEvent(event: Event): void {
    const target = event.target as HTMLElement
    const index = Array.from(target.parentElement?.children ?? []).indexOf(
      target,
    )
    const tab = this.tabLabels[index]
    if (tab === 'overview' || tab === 'queryNotes') {
      this.nav.setQueryParam('subtab', tab)
    }
  }

  getToolIcon = getToolIcon
}
